import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
import Vue from 'vue'

const bus = new Vue()

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API + '/' + process.env.API_PREFIX, // api的base_url
  timeout: 1000 * 15 // request timeout
})

service.interceptors.request.use(config => {
  if (store.state.token) { // 用户登录后
    config.headers['Authorization'] = getToken() // 让每个请求携带token
  }
  return config
}, error => {
  Promise.reject(error)
})

service.interceptors.response.use(
  response => {
    const res = response.data
    if (response.status !== 200) {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })
      return Promise.reject(response)
    } else {
      return response.data
    }
  },
  error => {
    if (error.response && error.response.status === 409) {
      Message({
        message: error.response.data.message,
        type: 'error',
        duration: 5 * 1000
      })
    } else if (error.response && error.response.status === 401) {
      Message({
        message: '登录失效，请重新登录',
        type: 'error',
        duration: 5 * 1000
      })
      Vue.$router.push('/login')
    } else {
      Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
      })
    }
    return Promise.reject(error)
  })
export default function (sendData, loading) {
  if (loading !== false) {
    bus.$myLoading.show()
  }
  if (loading) {
    bus.$myLoading.show()
  }
  return new Promise((resolve, reject) => {
    service(sendData).then(res => {
      resolve(res)
      if (loading !== false) {
        bus.$myLoading.hide()
      }
    }).catch(err => {
      reject(err)
      if (loading !== false) {
        bus.$myLoading.hide()
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/utils/request.js